const SIZES = [
  { value: "small",  label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large",  label: "Large" }
]

// Sizes the logo's exclusion zone — the module-snapped clearing the logo sits
// in. Only meaningful when a logo is set, so CustomizePanel renders it beneath
// the uploader once one is present. A larger zone clears more of the code; the
// server clamps it so it never eats the finder patterns.
export default function LogoSizeSelect({ value, onChange }) {
  const current = value || "medium"
  return (
    <fieldset className="mt-2">
      <legend className="sr-only">Logo size</legend>
      <div className="grid grid-cols-3 gap-2">
        {SIZES.map((s) => {
          const selected = current === s.value
          return (
            <label
              key={s.value}
              className={
                "flex items-center justify-center py-1.5 rounded border cursor-pointer transition text-xs font-semibold " +
                (selected
                  ? "border-voltage bg-voltage/5"
                  : "border-[color:var(--color-border)] dark:border-storm hover:border-voltage")
              }
            >
              <input
                type="radio"
                name="logo_size"
                value={s.value}
                checked={selected}
                onChange={() => onChange(s.value)}
                className="sr-only"
              />
              {s.label}
            </label>
          )
        })}
      </div>
      <p className="mt-1 text-xs text-[color:var(--color-muted)] dark:text-muted-light">
        Clear space for your logo. Snaps to whole modules so nothing gets cut.
      </p>
    </fieldset>
  )
}
